module.exports = __webpack_public_path__ + "static/media/9.2ace0b59.jpg";